import { jsx as _jsx } from "react/jsx-runtime";
import { SubtitleVariants } from "./constants";
import StyledSubtitle from "./Subtitle.style";
const Subtitle = ({ children, variant = SubtitleVariants.default, ...props }) => (_jsx(StyledSubtitle, { variant: variant, ...props, children: children }));
export default Subtitle;
//# sourceMappingURL=Subtitle.js.map